import utility from "../../../helpers/paymentHelpers/utility";

export default {
  namespaced: true,
  state: {
    allWalletModalOpen: false
  },
  getters: {},
  mutations: {
    updateAllWalletModalOpen(state, payload) {
			state.allWalletModalOpen =  payload;
		},
  },
  actions: {
    toggleAllWalletModal({ commit, state, dispatch }, payload) {
			if(payload) {
				document.body.classList.add("body-stop-scroll-mobile");
			} else {
				document.body.classList.remove("body-stop-scroll-mobile");
			}
			commit("updateAllWalletModalOpen", payload);
		},
  },
};
